// extracted by mini-css-extract-plugin
module.exports = {"header":"DashboardHeader_header__23A1D","downloadResultContainer":"DashboardHeader_downloadResultContainer__1QXGG"};